/**
 * This class deals with the interactive options related to page menus, specifically dropdowns. If enabled,
 */
class TMv_PageMenus {

	/**
	 * Constructor
	 * @param element
	 */
	constructor(element)
	{
		// Save the element for use in other methods
		this.element = element;

		// Determine if these menus are using dropdowns
		if(this.element?.classList.contains('use_dropdowns')) {
			// Find all the top_level menu items that have children
			this.element.querySelectorAll('.has_children > .TCv_Link').forEach(menu_item => {
				menu_item.addEventListener('click', this.handleNavMenuClick.bind(this));
			});
		}
	}


	/**
	 * Removes the show_menu class from all the elements
	 */
	removeShowMenuClasses() {
		this.element.querySelectorAll('.show_menu').forEach(el => {
			el.classList.remove('show_menu');
		});
	}

	/**
	 * Triggered when an appropriate item is selected
	 * @param {Event} event
	 */
	handleNavMenuClick(event) {

		// Link doesn't navigate, shows submenu
		event.preventDefault();

		// Handle when we are in mobile mode, which means all this stuff just doesn't happen
		// If you do, build it separately
		if(document.body.classList.contains('mobile_navigation_showing')) {
			return;
		}

		// Find out if we clicked on the same menu, which should toggle
		let is_same_menu = event.currentTarget.closest('li').classList.contains('show_menu');

		this.removeShowMenuClasses();

		// Find the parent LI, add the show_menu to the current menu item
		// Only bother if it's a different menu. Otherwise, the removal above handled hiding it (toggle)
		if(!is_same_menu)
		{
			event.currentTarget.closest('li').classList.add('show_menu');
		}

		// Tag the whole list has showing the menu
		this.element.classList.add('showing_menu');

	}

}